import React, { Component } from 'react'
import { FixedTeachersAndTAsComponent } from '.'
import lodashUtil from 'lodash';
import ElectivesFixedTeacherAndTAsComponent from './ElectivesFixedTeacherAndTAsComponent'
import { MuiGrid } from '../../../../../ui';
import { ConstraintsAndPreferences, CalculateUtil, rulesUtil, DialogComponentUtil } from '..';
import { gradePickerUtil } from '../../../../gradePicker';

class FixedTeachersAndTAsContainer extends Component {
  constructor(props) {
    super(props)
    let cellData = this.props.dataTableMap.get(this.props.cellCode)
    let fixedTeachersAndTAsForSubject = undefined;
    let fixedTeachersAndTAsForElective = undefined;
    let electiveId = undefined;
    let subjectId = undefined;
    let isElective = null;

    if (cellData.elective !== undefined) {
      fixedTeachersAndTAsForElective = {
        electiveId: cellData.elective._id,
        electiveName: cellData.elective.name,
        teachersAndTAs: [],
      }
      isElective = true;
    } else {
      fixedTeachersAndTAsForSubject = {
        subjectId: cellData.subject._id,
        subjectName: cellData.subject.name,
        subjectCode: cellData.subject.code,
        teachers: {
          fixed: [],
          preferred: []
        },
        TAs: {
          fixed: [],
          preferred: []
        }
      }
      isElective = false;
    }
    this.state = {
      keyArray: [],
      teacher: this.props.activeSchool.school_master.teachers,
      numberOfTeachers: [],
      numberOfTAs: [],
      fixedTeacher: [],
      fixedTAs: [],
      preferredTeacher: [],
      preferredTAs: [],
      fixedTeachersAndTAsForSubject: fixedTeachersAndTAsForSubject,
      fixedTeachersAndTAsForElective: fixedTeachersAndTAsForElective,
      fixedTeachersAndTAsForEleObj: {
        subjectId: subjectId,
        teachers: {
          fixed: [],
          preferred: []
        },
        TAs: {
          fixed: [],
          preferred: []
        }
      },
      teachersAndTAsAccor: false,
      subject: {},
      isElective: isElective,
      teachersAndTAsForElective: {
        teachersAndTAs: [],
      },
      numberOfTAsForPreferred: [],
      numberOfTeachersForPreferredTeacher: [],
      numberOfTeachersForFixedTeacher: [],
      numberOfTAsForFixedTeacher: [],
      tempActiveSchool: this.props.activeSchool,
      fixedSubjArray: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects)),
      fixedEleArray: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives))
    }
  }
  gettingTeachersForSubject = (subject) => {

    let teacher = this.state.teacher
    let isElective = this.state.isElective
    let cellDetails = this.props.dataTableMap.get(this.props.cellCode);
    let numberOfTeachers = [];
    let numberOfTAs = [];
    let gradeLevel = cellDetails.gradeLevel;
    let grade = cellDetails.grade;
    let group = cellDetails.group;
    let SubjectObj
    if (cellDetails.elective !== undefined) {
      isElective = true
      SubjectObj = subject
      this.setState({
        isElective: isElective
      })
    } else {
      isElective = false
      SubjectObj = cellDetails.subject
      this.setState({
        isElective: isElective
      })
    }

    let cellGradeDetailsLowestForm = []
    if (cellDetails.group !== undefined) {
      cellGradeDetailsLowestForm.push(`${cellDetails.grade}${cellDetails.group}`)
    } else {
      let gradeLevel = this.props.activeSchool.school_master.gradeLevels
      let gradeLevelObject = lodashUtil.find(gradeLevel, ["levelName", cellDetails.gradeLevel])
      let gradeObject = lodashUtil.find(gradeLevelObject.grades, ["gradeName", cellDetails.grade])
      for (let b = 0; b < gradeObject.groups.length; b++) {
        let groupCode = gradeObject.groups[b].groupName
        cellGradeDetailsLowestForm.push(`${cellDetails.grade}${groupCode}`)

      }
    }
    for (let i = 0; i < teacher.length; i++) {
      let assignedSubjects = teacher[i].assignedSubjects;
      let isSubjectPresent = undefined;

      if (SubjectObj !== undefined) {
        let subjectsArray = lodashUtil.filter(assignedSubjects, ['subjectName', SubjectObj.name])
        for (let a = 0; a < subjectsArray.length; a++) {
          let subObj = subjectsArray[a]
          let subGradesLowestForm = gradePickerUtil.convertingGradeDetailsToLowestFormat(subObj.gradeDetails, this.props)
          let gradeDetailsLowestForm = lodashUtil.difference(cellGradeDetailsLowestForm, subGradesLowestForm)
          if (gradeDetailsLowestForm.length === 0) {
            isSubjectPresent = subObj
            break
          }
        }

        this.setState({
          isElective: isElective
        })
      }

      if (isSubjectPresent !== undefined) {
        if (isSubjectPresent.gradeDetails.allGrades === true) {
          if (isSubjectPresent.isMainTeacher === true) {
            numberOfTeachers.push(teacher[i])
            continue;
          } else {
            numberOfTAs.push(teacher[i]);
            continue;
          }
        }
        else if (gradeLevel !== undefined && lodashUtil.find(isSubjectPresent.gradeDetails.gradeLevels, ["level", gradeLevel])) {
          if (isSubjectPresent.isMainTeacher === true) {
            numberOfTeachers.push(teacher[i])
            continue;
          } else {
            numberOfTAs.push(teacher[i]);
            continue;
          }
        }
        if (grade !== undefined && lodashUtil.find(isSubjectPresent.gradeDetails.grades, ['grade', grade])) {
          if (isSubjectPresent.isMainTeacher === true) {
            numberOfTeachers.push(teacher[i])
            continue;
          } else {
            numberOfTAs.push(teacher[i]);
            continue;
          }
        }

      }
    }
    this.setState({
      subject: subject,
      numberOfTeachers: numberOfTeachers,
      numberOfTAs: numberOfTAs,
    })
  }

  handleChangeForTeacherSubject = (name, event, value) => {
    let fixedTeachersAndTAsForSubject = this.state.fixedTeachersAndTAsForSubject
    if (name == "fixed") {
      fixedTeachersAndTAsForSubject.teachers.fixed = []
      value.map((fixed) => {
        let tempFixedObj = {
          teachersId: fixed._id == undefined ? fixed.teachersId : fixed._id,
          teacherId: fixed.teacherId
        }
        fixedTeachersAndTAsForSubject.teachers.fixed.push({ ...tempFixedObj })
        fixedTeachersAndTAsForSubject.teachers.fixed = lodashUtil.uniqBy(fixedTeachersAndTAsForSubject.teachers.fixed, "teacherId");
      })
    }
    else {
      fixedTeachersAndTAsForSubject.teachers.preferred = []
      value.map((preferred) => {
        let tempPreferredObj = {
          teachersId: preferred._id == undefined ? preferred.teachersId : preferred._id,
          teacherId: preferred.teacherId
        }
        fixedTeachersAndTAsForSubject.teachers.preferred.push({ ...tempPreferredObj })
        fixedTeachersAndTAsForSubject.teachers.preferred = lodashUtil.uniqBy(fixedTeachersAndTAsForSubject.teachers.preferred, "teacherId");
      })
    }
    this.setState({ fixedTeachersAndTAsForSubject: fixedTeachersAndTAsForSubject })
  }

  handleChangeForTAsSubject = (name, event, value) => {
    let fixedTeachersAndTAsForSubject = this.state.fixedTeachersAndTAsForSubject
    if (name == "fixed") {
      fixedTeachersAndTAsForSubject.TAs.fixed = []
      value.map((fixed) => {
        let tempFixedObj = {
          teachersId: fixed._id == undefined ? fixed.teachersId : fixed._id,
          teacherId: fixed.teacherId
        }
        fixedTeachersAndTAsForSubject.TAs.fixed.push({ ...tempFixedObj })
        fixedTeachersAndTAsForSubject.TAs.fixed = lodashUtil.uniqBy(fixedTeachersAndTAsForSubject.TAs.fixed, "teacherId");

      })
    }
    else {
      fixedTeachersAndTAsForSubject.TAs.preferred = []
      value.map((preferred) => {
        let tempPreferredObj = {
          teachersId: preferred._id == undefined ? preferred.teachersId : preferred._id,
          teacherId: preferred.teacherId
        }
        fixedTeachersAndTAsForSubject.TAs.preferred.push({ ...tempPreferredObj })
        fixedTeachersAndTAsForSubject.TAs.preferred = lodashUtil.uniqBy(fixedTeachersAndTAsForSubject.TAs.preferred, "teacherId");
      })
    }
    this.setState({ fixedTeachersAndTAsForSubject: fixedTeachersAndTAsForSubject })
  }

  handleChangeForTeachersElectives = (name, event, value, subject, index) => {
    let fixedTeachersAndTAsForElective = this.state.fixedTeachersAndTAsForElective
    let teachersAndTAs = fixedTeachersAndTAsForElective.teachersAndTAs

    if (teachersAndTAs[index].subjectId === subject._id) {
      if (name == "fixed") {
        teachersAndTAs[index].teachers.fixed = []
        value.map((fixed) => {
          let tempFixedObj = {
            teachersId: fixed._id == undefined ? fixed.teachersId : fixed._id,
            teacherId: fixed.teacherId
          }
          teachersAndTAs[index].teachers.fixed.push({ ...tempFixedObj })
          teachersAndTAs[index].teachers.fixed = lodashUtil.uniqBy(teachersAndTAs[index].teachers.fixed, "teacherId");

        })
      }
      else {
        teachersAndTAs[index].teachers.preferred = []
        value.map((preferred) => {
          let tempPreferredObj = {
            teachersId: preferred._id == undefined ? preferred.teachersId : preferred._id,
            teacherId: preferred.teacherId
          }
          teachersAndTAs[index].teachers.preferred.push({ ...tempPreferredObj })
          teachersAndTAs[index].teachers.preferred = lodashUtil.uniqBy(teachersAndTAs[index].teachers.preferred, "teacherId");
        })
      }
    }
    this.setState({ fixedTeachersAndTAsForElective: fixedTeachersAndTAsForElective })
  }
  handleChangeForTAsElectives = (name, event, value, subject, index) => {
    let fixedTeachersAndTAsForElective = this.state.fixedTeachersAndTAsForElective
    let teachersAndTAs = fixedTeachersAndTAsForElective.teachersAndTAs

    if (teachersAndTAs.length !== 0) {
      if (teachersAndTAs[index].subjectId == subject._id) {
        if (name == "fixed") {
          teachersAndTAs[index].TAs.fixed = []
          value.map((fixed) => {
            let tempFixedTAsObj = {
              teachersId: fixed._id == undefined ? fixed.teachersId : fixed._id,
              teacherId: fixed.teacherId
            }
            teachersAndTAs[index].TAs.fixed.push({ ...tempFixedTAsObj })
            teachersAndTAs[index].TAs.fixed = lodashUtil.uniqBy(teachersAndTAs[index].TAs.fixed, "teacherId");
          })
        }
        else {
          teachersAndTAs[index].TAs.preferred = []
          value.map((preferred) => {
            let tempPreferredTAsObj = {
              teachersId: preferred._id == undefined ? preferred.teachersId : preferred._id,
              teacherId: preferred.teacherId
            }
            teachersAndTAs[index].TAs.preferred.push({ ...tempPreferredTAsObj })
            teachersAndTAs[index].TAs.preferred = lodashUtil.uniqBy(teachersAndTAs[index].TAs.preferred, "teacherId");
          })
        }
      }

    }
    this.setState({ fixedTeachersAndTAsForElective: fixedTeachersAndTAsForElective })
  }
  componentWillMount = () => {
    if (this.props.dataTableMap.get(this.props.cellCode).elective !== undefined) {
      // "CONSTRUCTION OF DATA FOR FIRST TIME" if there is no previous data then construct the required one.
      if (this.props.dataTableMap.get(this.props.cellCode).fixedTeachersAndTAsForElective === undefined) {
        this.generateElectivObj();
      }
      this.showExistingFixedTeachersAndTAsForElectives();
      let elective = this.props.dataTableMap.get(this.props.cellCode).elective;
      this.setState({ elective: elective });
    } else {
      this.showExistingFixedTeachersAndTAsForSubjects();
    }

    this.gettingTeachersForSubject(this.state.subject)
  }

  generateElectivObj = () => {
    let fixedTeachersAndTAsForElective = this.state.fixedTeachersAndTAsForElective;
    let teachersAndTAs = [...fixedTeachersAndTAsForElective.teachersAndTAs];
    let fixedTeachersAndTAsForEleObj = this.state.fixedTeachersAndTAsForEleObj;
    let cellDetails = this.props.dataTableMap.get(this.props.cellCode);

    for (let i = 0; i < cellDetails.elective.subjects.length; i++) {
      fixedTeachersAndTAsForEleObj.subjectId = cellDetails.elective.subjects[i]._id;
      fixedTeachersAndTAsForEleObj.subjectName = cellDetails.elective.subjects[i].name;
      fixedTeachersAndTAsForEleObj.subjectCode = cellDetails.elective.subjects[i].subjectCode;
      fixedTeachersAndTAsForElective.teachersAndTAs.push(JSON.parse(JSON.stringify(fixedTeachersAndTAsForEleObj)));
    }
    this.setState({ fixedTeachersAndTAsForElective: fixedTeachersAndTAsForElective });
  }

  showTeachersAndTAs = (subject) => {
    this.setState({
      subject: subject,
      teachersAndTAsAccor: !this.state.teachersAndTAsAccor
    })
    this.gettingTeachersForSubject(subject)
  }

  onClickOfSave = async () => {
    if (this.state.isElective === true) {
      this.onClickOfSaveForElectives()
    } else {
      this.onClickOfSaveForSubjects();
    }
  }

  onClickOfSaveForSubjects = async () => {
    let tempActiveSchool = this.state.tempActiveSchool;
    let keys = this.props.keys;
    let cellDetails = undefined;
    let templetObjForCreatingNewObj = undefined;
    let gradeLevels = this.props.activeSchool.school_master.gradeLevels
    let fixedTeachersAndTAsForSubjects = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects
    let fixedTeachersAndTAsForSubject = JSON.parse(JSON.stringify(this.state.fixedTeachersAndTAsForSubject));
    let fixedTeachersAndTAsForSubjectString = rulesUtil.getFixedTeachersAndTAsForSubject(fixedTeachersAndTAsForSubject);
    fixedTeachersAndTAsForSubject.showFixedTeachersForSubjectString = fixedTeachersAndTAsForSubjectString.teachersForSubjectString;
    fixedTeachersAndTAsForSubject.showFixedTAsForSubjectString = fixedTeachersAndTAsForSubjectString.tAsForSubjectString;
    if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
      tempActiveSchool.schedule_constraints = [
        { fixedTeachersAndTAsForSubjects: [] }
      ]
    }

    //KEYS 
    for (let c = 0; c < keys.length; c++) {
      cellDetails = this.props.dataTableMap.get(keys[c]);
      // gradeDetails from subject or elective 
      let cellGradeDetails = undefined;
      if (cellDetails.subject !== undefined) {
        cellGradeDetails = cellDetails.subject.gradeDetails
      } else if (cellDetails.elective !== undefined) {
        cellGradeDetails = cellDetails.elective.gradeDetails
      }
      // "EDIT" if fixedTeachersAndTAsForSubject is already present 
      if (cellDetails.fixedTeachersAndTAsForSubject !== undefined) {
        //EDITING FOR GROUPS
        if (this.props.filter.showSections === true) {
          let count = 0;
          let index = undefined;
          let cellDetails_fixedTeachersAndTAsForSubject = cellDetails.fixedTeachersAndTAsForSubject

          let newFixedTeachers = this.state.fixedTeacher;
          let newPreferredTeachers = this.state.preferredTeacher
          let newFixedTAs = this.state.fixedTAs
          let newPreferredTAs = this.state.preferredTAs

          let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(fixedTeachersAndTAsForSubjects, cellDetails_fixedTeachersAndTAsForSubject)
          let teachersFixedFlag = false;
          let teachersPreferredFlag = false;
          let TAsFixedFlag = false;
          let TAsPreferredFlag = false;

          if (objIndex != undefined) {
            let obj = fixedTeachersAndTAsForSubjects[objIndex]
            let oldTeachers = obj.teachers;
            let oldTAs = obj.TAs;
            //COMPARING TWO OBJECTS TO CHECK IF THE DATA IS SAME.

            //"TEACHERS => FIXED" chek new and old obj has the same length 
            if (newFixedTeachers.length === oldTeachers.fixed.length) {
              if (newFixedTeachers.length !== 0) {
                let fixedTeacherCount = 0
                for (let m = 0; m < newFixedTeachers.length; m++) {
                  if (newFixedTeachers[m].teachersId === oldTeachers.fixed[m].teachersId) {
                    fixedTeacherCount++
                    if (fixedTeacherCount === newFixedTeachers.length) {
                      teachersFixedFlag = true;
                    }
                  }
                }
              } else {
                teachersFixedFlag = true;
              }
            }

            //"TEACHERS => PREFERRED" if new and old obj matches everything  
            if (newPreferredTeachers.length === oldTeachers.preferred.length) {
              if (newPreferredTeachers.length !== 0) {
                let preferredTeacherCount = 0;
                for (let n = 0; n < newPreferredTeachers.length; n++) {
                  if (newPreferredTeachers[n].teachersId === oldTeachers.preferred[n].teachersId) {
                    preferredTeacherCount++;
                    if (preferredTeacherCount === newPreferredTeachers.length) {
                      teachersPreferredFlag = true;
                    }
                  }
                }
              } else {
                teachersPreferredFlag = true;
              }
            }
            //"TAs => FIXED" chek new and old obj has the same length 
            if (newFixedTAs.length === oldTAs.fixed.length) {
              if (newFixedTAs.length !== 0) {
                let fixedTAsCount = 0
                for (let m = 0; m < newFixedTAs.length; m++) {
                  if (newFixedTAs[m].teachersId === oldTAs.fixed[m].teachersId) {
                    fixedTAsCount++
                    if (fixedTAsCount === newFixedTAs.length) {
                      TAsFixedFlag = true;
                    }
                  }
                }
              } else {
                TAsFixedFlag = true;
              }
            }
            //"TAs => PREFERRED" if new and old obj matches everything  
            if (newPreferredTAs.length === oldTAs.preferred.length) {
              if (newPreferredTAs.length !== 0) {
                let preferredTAsCount = 0;
                for (let n = 0; n < newPreferredTAs.length; n++) {
                  if (newPreferredTAs[n].teachersId === oldTAs.preferred[n].teachersId) {
                    preferredTAsCount++;
                    if (preferredTAsCount === newPreferredTAs.length) {
                      TAsPreferredFlag = true;
                    }
                  }
                }
              } else {
                TAsPreferredFlag = true;
              }
            }
          }

          if (teachersFixedFlag === false
            || teachersPreferredFlag === false
            || TAsFixedFlag === false
            || TAsPreferredFlag === false) {
            // remove obj code 
            for (let d = 0; d < fixedTeachersAndTAsForSubjects.length; d++) {
              let gradeObj = fixedTeachersAndTAsForSubjects[d].gradeDetails.grades[0]
              if ((cellDetails.subject && cellDetails.subject._id == fixedTeachersAndTAsForSubjects[d].subjectId)) {
                if (gradeObj.grade === cellDetails.grade) {
                  count++
                  if (gradeObj.groups.length === 0) {
                    index = d;
                  }

                }
              }
            }
            // SPLICE
            let subGradeObj;
            let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
            if (isLevelPresent !== undefined) {
              let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
              if (gradeLevelObj !== undefined)
                subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
            } else {
              subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
            }
            // check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
            if (cellGradeDetails.allGrades === true
              || cellGradeDetails.gradeLevels.length !== 0
              || subGradeObj.groups.length === 0) {
              for (let p = 0; p < gradeLevels.length; p++) {
                let gradeLevel = gradeLevels[p]
                let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
                if (selectedObj !== undefined) {
                  if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
                    fixedTeachersAndTAsForSubjects.splice(index, 1);
                    break;
                  }
                }
              }
            }
            // SUBJECT is there only for SOME GROUPS in that grade.
            else {
              if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
                fixedTeachersAndTAsForSubjects.splice(index, 1);
              }
            }
            // REPLACING the object for GROUPS
            let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(fixedTeachersAndTAsForSubjects, cellDetails_fixedTeachersAndTAsForSubject)
            if (objectIndex !== undefined) {
              fixedTeachersAndTAsForSubjects[objectIndex].teachers = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject.teachers))
              fixedTeachersAndTAsForSubjects[objectIndex].TAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject.TAs))
              fixedTeachersAndTAsForSubjects[objectIndex].showFixedTeachersForSubjectString = fixedTeachersAndTAsForSubject.showFixedTeachersForSubjectString
              fixedTeachersAndTAsForSubjects[objectIndex].showFixedTAsForSubjectString = fixedTeachersAndTAsForSubject.showFixedTAsForSubjectString
            }
          }
          //if user has not changed the data and clicked on save 
          else {
            // continue with the next key withought saving 
            continue;
          }
        }
        //"EDITING FOR GRADES" show sections is false so we are clicking on grades which already has the data 
        else {
          let cellDetails_fixedTeachersAndTAsForSubject = cellDetails.fixedTeachersAndTAsForSubject

          let newFixedTeachers = this.state.fixedTeacher;
          let newPreferredTeachers = this.state.preferredTeacher
          let newFixedTAs = this.state.fixedTAs
          let newPreferredTAs = this.state.preferredTAs

          let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(fixedTeachersAndTAsForSubjects, cellDetails_fixedTeachersAndTAsForSubject)

          let teachersFixedFlag = false;
          let teachersPreferredFlag = false;
          let TAsFixedFlag = false;
          let TAsPreferredFlag = false;
          if (objIndex != undefined) {
            let obj = fixedTeachersAndTAsForSubjects[objIndex]
            let oldTeachers = obj.teachers;
            let oldTAs = obj.TAs;
            //COMPARING TWO OBJECTS TO CHECK IF THE DATA IS SAME.

            //"TEACHERS => FIXED" chek new and old obj has the same length 
            if (newFixedTeachers.length === oldTeachers.fixed.length) {
              if (newFixedTeachers.length !== 0) {
                let fixedTeacherCount = 0
                for (let m = 0; m < newFixedTeachers.length; m++) {
                  if (newFixedTeachers[m].teachersId === oldTeachers.fixed[m].teachersId) {
                    fixedTeacherCount++
                    if (fixedTeacherCount === newFixedTeachers.length) {
                      teachersFixedFlag = true;
                    }
                  }
                }
              } else {
                teachersFixedFlag = true;
              }
            }

            //"TEACHERS => PREFERRED" if new and old obj matches everything  
            if (newPreferredTeachers.length === oldTeachers.preferred.length) {
              if (newPreferredTeachers.length !== 0) {
                let preferredTeacherCount = 0;
                for (let n = 0; n < newPreferredTeachers.length; n++) {
                  if (newPreferredTeachers[n].teachersId === oldTeachers.preferred[n].teachersId) {
                    preferredTeacherCount++;
                    if (preferredTeacherCount === newPreferredTeachers.length) {
                      teachersPreferredFlag = true;
                    }
                  }
                }
              } else {
                teachersPreferredFlag = true;
              }
            }
            //"TAs => FIXED" chek new and old obj has the same length 
            if (newFixedTAs.length === oldTAs.fixed.length) {
              if (newFixedTAs.length !== 0) {
                let fixedTAsCount = 0
                for (let m = 0; m < newFixedTAs.length; m++) {
                  if (newFixedTAs[m].teachersId === oldTAs.fixed[m].teachersId) {
                    fixedTAsCount++
                    if (fixedTAsCount === newFixedTAs.length) {
                      TAsFixedFlag = true;
                    }
                  }
                }
              } else {
                TAsFixedFlag = true;
              }
            }
            //"TAs => PREFERRED" if new and old obj matches everything  
            if (newPreferredTAs.length === oldTAs.preferred.length) {
              if (newPreferredTAs.length !== 0) {
                let preferredTAsCount = 0;
                for (let n = 0; n < newPreferredTAs.length; n++) {
                  if (newPreferredTAs[n].teachersId === oldTAs.preferred[n].teachersId) {
                    preferredTAsCount++;
                    if (preferredTAsCount === newPreferredTAs.length) {
                      TAsPreferredFlag = true;
                    }
                  }
                }
              } else {
                TAsPreferredFlag = true;
              }
            }
          }

          if (teachersFixedFlag === false
            || teachersPreferredFlag === false
            || TAsFixedFlag === false
            || TAsPreferredFlag === false) {
            //all the groups should eb over ridden with this value
            for (let h = 0; h < fixedTeachersAndTAsForSubjects.length; h++) {

              if ((cellDetails.subject && cellDetails.subject._id == fixedTeachersAndTAsForSubjects[h].subjectId)) {
                if (fixedTeachersAndTAsForSubjects[h].gradeDetails.grades[0].grade === cellDetails.grade) {
                  fixedTeachersAndTAsForSubjects[h].teachers = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject.teachers))
                  fixedTeachersAndTAsForSubjects[h].TAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject.TAs))
                  fixedTeachersAndTAsForSubjects[h].showFixedTeachersForSubjectString = fixedTeachersAndTAsForSubject.showFixedTeachersForSubjectString
                  fixedTeachersAndTAsForSubjects[h].showFixedTAsForSubjectString = fixedTeachersAndTAsForSubject.showFixedTAsForSubjectString

                  if (fixedTeachersAndTAsForSubjects[h].gradeDetails.grades[0].groups.length != 0) {
                    if (templetObjForCreatingNewObj === undefined) {
                      templetObjForCreatingNewObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubjects[h]))
                    }
                  }
                }

              }
            }
          }
          this.creatingFixedTeachersAndTAsForSubjectsObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
        }
      }

      //"NEW OBJECT" if fixedTeachersAndTAsForSubject is not present in the schedule constraint
      else {
        // if the selected cell is for the grade and not for groups
        if (cellDetails.group === undefined) {
          //grade's object from master
          for (let g = 0; g < gradeLevels.length; g++) {
            let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
            //GRADE (groups is empty)
            if (gradeObj !== undefined) {
              let fixedTeachersAndTAsForSubjectObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject));
              let gradeDetails = {
                allGrades: false,
                gradeLevels: [{
                  level: cellDetails.gradeLevel
                }],
                grades: [{
                  grade: cellDetails.grade,
                  groups: [],
                }],
              }

              fixedTeachersAndTAsForSubjectObj.gradeDetails = gradeDetails;
              tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects.push(fixedTeachersAndTAsForSubjectObj);

              let existingGroupArray = [];

              //when GRADE is new and  GROUPS is present it needs to be REPLACED  
              for (let x = 0; x < fixedTeachersAndTAsForSubjects.length; x++) {
                if ((cellDetails.subject && cellDetails.subject._id == fixedTeachersAndTAsForSubjects[x].subjectId)) {
                  if (fixedTeachersAndTAsForSubjects[x].gradeDetails.grades[0].grade === cellDetails.grade
                    && fixedTeachersAndTAsForSubjects[x].gradeDetails.grades[0].groups.length > 0) {

                    existingGroupArray.push(fixedTeachersAndTAsForSubjects[x].gradeDetails.grades[0].groups[0].groupCode)

                    fixedTeachersAndTAsForSubjects[x].teachers = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject.teachers))
                    fixedTeachersAndTAsForSubjects[x].TAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject.TAs))
                    fixedTeachersAndTAsForSubjects[x].showFixedTeachersForSubjectString = fixedTeachersAndTAsForSubject.showFixedTeachersForSubjectString
                    fixedTeachersAndTAsForSubjects[x].showFixedTAsForSubjectString = fixedTeachersAndTAsForSubject.showFixedTAsForSubjectString

                    if (templetObjForCreatingNewObj === undefined) {
                      templetObjForCreatingNewObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubjects[x]))
                    }
                  }
                }
              }
              // to create NEW data to all the groups  
              //  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
              let commonGradeObj;
              let cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
              let gradeObj = undefined
              for (let t = 0; gradeLevels.length; t++) {
                let gradeLevel = gradeLevels[t];
                gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
                if (gradeObj !== undefined) {
                  break;
                }
              }
              if (cellGradeDetails !== undefined) {
                commonGradeObj = gradeObj;
              }

              for (let m = 0; m < commonGradeObj.groups.length; m++) {
                // AFTER GRADE => GROUPS
                if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
                  let fixedTeachersAndTAsForSubjectObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject));
                  let gradeDetails = {
                    allGrades: false,
                    gradeLevels: [{
                      level: cellDetails.gradeLevel
                    }],
                    grades: [{
                      grade: cellDetails.grade,
                      groups: [{
                        groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
                      }],
                    }],
                  }
                  fixedTeachersAndTAsForSubjectObj.gradeDetails = gradeDetails;
                  tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects.push(fixedTeachersAndTAsForSubjectObj)

                  if (templetObjForCreatingNewObj === undefined) {
                    templetObjForCreatingNewObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubjectObj))
                  }
                }
              }
              break;
            }
          }
          this.creatingFixedTeachersAndTAsForSubjectsObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
        }
        // selected cell for GROUPS
        else {
          let fixedTeachersAndTAsForSubjectObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubject));
          let gradeDetails = {
            allGrades: false,
            gradeLevels: [{
              level: cellDetails.gradeLevel
            }],
            grades: [{
              grade: cellDetails.grade,
              groups: [
                { groupCode: cellDetails.group }
              ],
            }],
          }
          fixedTeachersAndTAsForSubjectObj.gradeDetails = gradeDetails;
          if (cellDetails.jointClass !== undefined) {
            fixedTeachersAndTAsForSubjectObj.jointClassId = cellDetails.jointClass._id
          }
          fixedTeachersAndTAsForSubjects.push(fixedTeachersAndTAsForSubjectObj)
        }

      }
    }
    tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
      ConstraintsAndPreferences.Constants.FIXED_TEACHERS_AND_TAS_FOR_SUBJECTS
    )

    await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
    this.attachingDataToCellForSubjects();
    this.props.handleCloseForDialog();
    this.props.handleClose();
  }

  creatingFixedTeachersAndTAsForSubjectsObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
    let cellDetails_grade = cellDetails.grade
    let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
    let fixedTeachersAndTAsForSubjectsArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects

    //JOINT CLASS ARRAY
    for (let a = 0; a < jointClassArray.length; a++) {
      let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
      if (cellDetails.subject && cellDetails.subject._id == jointClassObj.subjectId) {
        let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

        let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
        if (gradeIndex != -1) {

          //JOINT CLASS GRADE 
          for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
            let gradeObj = gradeDetails_gradesArray[b]

            // JOINT CLASS GROUPS 
            for (let c = 0; c < gradeObj.groups.length; c++) {
              let groupObj = gradeObj.groups[c];
              let isGroupObjPresent = false;

              //FIXED TEACHERS AND TAS FOR SUBJECTS FROM DATABASE
              for (let d = 0; d < fixedTeachersAndTAsForSubjectsArray.length; d++) {
                let fixedTeachersAndTAsForSubjectObj = fixedTeachersAndTAsForSubjectsArray[d];
                let fixedTeachersAndTAsForSubjectObj_grades = fixedTeachersAndTAsForSubjectObj.gradeDetails.grades[0]
                // REPLACING THE VALUES IN THE DATABASE ARRAY
                if (fixedTeachersAndTAsForSubjectObj_grades.grade === gradeObj.grade
                  && fixedTeachersAndTAsForSubjectObj_grades.groups != undefined
                  && fixedTeachersAndTAsForSubjectObj_grades.groups.length > 0
                  && fixedTeachersAndTAsForSubjectObj_grades.groups[0].groupCode === groupObj.groupCode) {

                  fixedTeachersAndTAsForSubjectObj.teachers = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.teachers))
                  fixedTeachersAndTAsForSubjectObj.TAs = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.TAs))
                  fixedTeachersAndTAsForSubjectObj.showFixedTeachersForSubjectString = templetObjForCreatingNewObj.showFixedTeachersForSubjectString
                  fixedTeachersAndTAsForSubjectObj.showFixedTAsForSubjectString = templetObjForCreatingNewObj.showFixedTAsForSubjectString
                  fixedTeachersAndTAsForSubjectObj.jointClassId = jointClassObj._id
                  isGroupObjPresent = true
                  break;
                }
              }

              // CREATE NEW OBJECT FOR PARTICULAR GROUPS
              if (isGroupObjPresent === false) {
                let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
                delete tempObj._id;
                tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
                tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
                tempObj.jointClassId = jointClassObj._id
                fixedTeachersAndTAsForSubjectsArray.push(tempObj);
              }
            }
          }
        }
      }
    }
  }


  onClickOfSaveForElectives = async () => {
    let tempActiveSchool = this.state.tempActiveSchool;
    //tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].modifiedDate = new Date();
    let keys = this.props.keys;
    let cellDetails = undefined;
    let gradeLevels = this.props.activeSchool.school_master.gradeLevels
    let objMatching = false;
    let templetObjForCreatingNewObj = undefined;
    let fixedTeachersAndTAsForElectives = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives

    let fixedTeachersAndTAsForElective = JSON.parse(JSON.stringify(this.state.fixedTeachersAndTAsForElective))
    for (let f = 0; f < fixedTeachersAndTAsForElective.teachersAndTAs.length; f++) {
      let teachersAndTAsObj = fixedTeachersAndTAsForElective.teachersAndTAs[f];
      let fixedTeachersAndTAsForSubjectString = rulesUtil.getFixedTeachersAndTAsForSubject(teachersAndTAsObj)
      teachersAndTAsObj.showFixedTeachersForSubjectString = fixedTeachersAndTAsForSubjectString.teachersForSubjectString;
      teachersAndTAsObj.showFixedTAsForSubjectString = fixedTeachersAndTAsForSubjectString.tAsForSubjectString;
    }

    if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
      tempActiveSchool.schedule_constraints = [
        { fixedTeachersAndTAsForElectives: [] }
      ]
    }

    //KEYS 
    for (let c = 0; c < keys.length; c++) {
      cellDetails = this.props.dataTableMap.get(keys[c]);
      // gradeDetails from subject or elective 
      let cellGradeDetails = undefined;
      if (cellDetails.elective !== undefined) {
        cellGradeDetails = cellDetails.elective.gradeDetails
      }

      // "EDIT" if fixedTeachersAndTAsForElective is already present 
      if (cellDetails.fixedTeachersAndTAsForElective !== undefined) {
        //EDITING FOR GROUPS
        if (this.props.filter.showSections === true) {

          let count = 0;
          let index = undefined;
          let cellDetails_fixedTeachersAndTAsForElective = cellDetails.fixedTeachersAndTAsForElective
          let teachersAndTAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective.teachersAndTAs))
          let objMatching = false;
          let objTrueCount = 0;

          // COMPARE TWO ARRAY TO FIND IF THE VALUES HAVE BEEN CHANGED IN 2 PLACES 
          let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(fixedTeachersAndTAsForElectives, cellDetails_fixedTeachersAndTAsForElective)
          if (objIndex === undefined) {
            objMatching = false
          } else {
            let obj = fixedTeachersAndTAsForElectives[objIndex]
            for (let q = 0; q < teachersAndTAs.length; q++) {

              //ALl the flag 
              let teachersFixedFlag = false;
              let teachersPreferredFlag = false;
              let TAsFixedFlag = false;
              let TAsPreferredFlag = false;

              let newFixedTeachers = teachersAndTAs[q].teachers.fixed;
              let newPreferredTeachers = teachersAndTAs[q].teachers.preferred;
              let newFixedTAs = teachersAndTAs[q].TAs.fixed;
              let newPreferredTAs = teachersAndTAs[q].TAs.preferred;
              let oldTeachers = obj.teachersAndTAs[q].teachers;
              let oldTAs = obj.teachersAndTAs[q].TAs;

              //COMPARING TWO OBJECTS TO CHECK IF THE DATA IS SAME.
              //"TEACHERS => FIXED" check new and old obj has the same length 
              if (newFixedTeachers.length === oldTeachers.fixed.length) {
                if (newFixedTeachers.length !== 0) {
                  let fixedTeacherCount = 0
                  for (let m = 0; m < newFixedTeachers.length; m++) {
                    if (newFixedTeachers[m].teachersId === oldTeachers.fixed[m].teachersId) {
                      fixedTeacherCount++
                      if (fixedTeacherCount === newFixedTeachers.length) {
                        teachersFixedFlag = true;
                      }
                    }
                  }
                } else {
                  teachersFixedFlag = true;
                }
              }

              //"TEACHERS => PREFERRED" if new and old obj matches everything  
              if (newPreferredTeachers.length === oldTeachers.preferred.length) {
                if (newPreferredTeachers.length !== 0) {
                  let preferredTeacherCount = 0;
                  for (let n = 0; n < newPreferredTeachers.length; n++) {
                    if (newPreferredTeachers[n].teachersId === oldTeachers.preferred[n].teachersId) {
                      preferredTeacherCount++;
                      if (preferredTeacherCount === newPreferredTeachers.length) {
                        teachersPreferredFlag = true;
                      }
                    }
                  }
                } else {
                  teachersPreferredFlag = true;
                }
              }
              //"TAs => FIXED" check new and old obj has the same length 
              if (newFixedTAs.length === oldTAs.fixed.length) {
                if (newFixedTAs.length !== 0) {
                  let fixedTAsCount = 0
                  for (let m = 0; m < newFixedTAs.length; m++) {
                    if (newFixedTAs[m].teachersId === oldTAs.fixed[m].teachersId) {
                      fixedTAsCount++
                      if (fixedTAsCount === newFixedTAs.length) {
                        TAsFixedFlag = true;
                      }
                    }
                  }
                } else {
                  TAsFixedFlag = true;
                }
              }
              //"TAs => PREFERRED" if new and old obj matches everything  
              if (newPreferredTAs.length === oldTAs.preferred.length) {
                if (newPreferredTAs.length !== 0) {
                  let preferredTAsCount = 0;
                  for (let n = 0; n < newPreferredTAs.length; n++) {
                    if (newPreferredTAs[n].teachersId === oldTAs.preferred[n].teachersId) {
                      preferredTAsCount++;
                      if (preferredTAsCount === newPreferredTAs.length) {
                        TAsPreferredFlag = true;
                      }
                    }
                  }
                } else {
                  TAsPreferredFlag = true;
                }
              }

              // check if the first array everything is amtching (true ) only then go into the nex iteration 
              if (teachersFixedFlag === true
                && teachersPreferredFlag === true
                && TAsFixedFlag === true
                && TAsPreferredFlag === true) {
                objTrueCount++;
                if (objTrueCount === teachersAndTAs.length) {
                  objMatching = true;
                }
                continue
              } else {
                break;
              }
            }
          }

          if (objMatching === false) {
            for (let d = 0; d < fixedTeachersAndTAsForElectives.length; d++) {
              let gradeObj = fixedTeachersAndTAsForElectives[d].gradeDetails.grades[0]
              if ((cellDetails.elective && cellDetails.elective._id == fixedTeachersAndTAsForElectives[d].electiveId)) {
                if (gradeObj.grade === cellDetails.grade) {
                  count++
                  if (gradeObj.groups.length === 0) {
                    index = d;
                  }

                }
              }
            }
            // SPLICE
            let subGradeObj;
            let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
            if (isLevelPresent !== undefined) {
              let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
              if (gradeLevelObj !== undefined) {
                subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
              }
            } else {
              subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
            }
            // check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
            if (cellGradeDetails.allGrades === true
              || cellGradeDetails.gradeLevel !== 0
              || subGradeObj.groups.length === 0) {
              for (let p = 0; p < gradeLevels.length; p++) {
                let gradeLevel = gradeLevels[p]
                let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
                if (selectedObj !== undefined) {
                  if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
                    fixedTeachersAndTAsForElectives.splice(index, 1);
                    break;
                  }
                }
              }
            }
            // SUBJECT is there only for SOME GROUPS in that grade.
            else {
              if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
                fixedTeachersAndTAsForElectives.splice(index, 1);
              }
            }

            // GROUPS REPLACING 
            let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(fixedTeachersAndTAsForElectives, cellDetails_fixedTeachersAndTAsForElective)
            if (objectIndex !== -1) {
              fixedTeachersAndTAsForElectives[objectIndex].teachersAndTAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective.teachersAndTAs))
            }
          }


        }
        //"GRADES" show sections is false so we are clicking on grades which already has the data 
        else {
          let objMatching = false;

          if (objMatching === false) {
            //all the groups should eb over ridden with this value
            for (let h = 0; h < fixedTeachersAndTAsForElectives.length; h++) {

              if ((cellDetails.elective && cellDetails.elective._id == fixedTeachersAndTAsForElectives[h].electiveId)) {
                if (fixedTeachersAndTAsForElectives[h].gradeDetails.grades[0].grade === cellDetails.grade) {
                  fixedTeachersAndTAsForElectives[h].teachersAndTAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective.teachersAndTAs));

                  if (fixedTeachersAndTAsForElectives[h].gradeDetails.grades[0].groups.length != 0) {
                    if (templetObjForCreatingNewObj === undefined) {
                      templetObjForCreatingNewObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElectives[h]))
                    }
                  }
                }

              }
            }
          }
          this.creatingFixedTeachersAndTAsForElectivesObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
        }
      }

      //"NEW OBJECT" if obj is not present in the schedule constraint
      else {
        // if the selected cell is for the grade and not for groups
        if (cellDetails.group === undefined) {
          //grade's object from master
          for (let g = 0; g < gradeLevels.length; g++) {
            let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);

            //GRADE (groups is empty)
            if (gradeObj !== undefined) {
              let fixedTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective));
              // let electiveTempObj = {
              let gradeDetails = {
                allGrades: false,
                gradeLevels: [{
                  level: cellDetails.gradeLevel
                }],
                grades: [{
                  grade: cellDetails.grade,
                  groups: [],
                }],
              }

              fixedTeachersAndTAsForElectiveObj.gradeDetails = gradeDetails
              tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives.push(fixedTeachersAndTAsForElectiveObj);

              let existingGroupArray = [];

              for (let x = 0; x < fixedTeachersAndTAsForElectives.length; x++) {
                if ((cellDetails.elective && cellDetails.elective._id == fixedTeachersAndTAsForElectives[x].electiveId)) {
                  if (fixedTeachersAndTAsForElectives[x].gradeDetails.grades[0].grade === cellDetails.grade
                    && fixedTeachersAndTAsForElectives[x].gradeDetails.grades[0].groups.length > 0) {

                    existingGroupArray.push(fixedTeachersAndTAsForElectives[x].gradeDetails.grades[0].groups[0].groupCode)

                    fixedTeachersAndTAsForElectives[x].teachersAndTAs = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective.teachersAndTAs));

                    if (templetObjForCreatingNewObj === undefined) {
                      templetObjForCreatingNewObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElectives[x]))
                    }

                  }
                }
              }
              // to create NEW data to all the groups  
              //  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
              let commonGradeObj;
              let cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
              let gradeObj = undefined
              for (let t = 0; gradeLevels.length; t++) {
                let gradeLevel = gradeLevels[t];
                gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
                if (gradeObj !== undefined) {
                  break;
                }
              }
              if (cellGradeDetails !== undefined) {
                commonGradeObj = gradeObj;
              }

              for (let m = 0; m < commonGradeObj.groups.length; m++) {
                // AFTER GRADE => GROUPS
                if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
                  let fixedTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective));
                  let gradeDetails = {
                    allGrades: false,
                    gradeLevels: [{
                      level: cellDetails.gradeLevel
                    }],
                    grades: [{
                      grade: cellDetails.grade,
                      groups: [{
                        groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
                      }],
                    }],
                  }
                  fixedTeachersAndTAsForElectiveObj.gradeDetails = gradeDetails
                  tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives.push(fixedTeachersAndTAsForElectiveObj);

                  if (templetObjForCreatingNewObj === undefined) {
                    templetObjForCreatingNewObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElectiveObj))
                  }
                }
              }
              break;
            }
          }
          this.creatingFixedTeachersAndTAsForElectivesObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
        }
        // selected cell for GROUPS
        else {
          let fixedTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForElective));
          let gradeDetails = {
            allGrades: false,
            gradeLevels: [{
              level: cellDetails.gradeLevel
            }],
            grades: [{
              grade: cellDetails.grade,
              groups: [
                { groupCode: cellDetails.group }
              ],
            }],
          }
          fixedTeachersAndTAsForElectiveObj.gradeDetails = gradeDetails
          if (cellDetails.jointClass !== undefined) {
            fixedTeachersAndTAsForElectiveObj.jointClassId = cellDetails.jointClass._id
          }
          fixedTeachersAndTAsForElectives.push(fixedTeachersAndTAsForElectiveObj);
        }
      }
    }
    tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
      ConstraintsAndPreferences.Constants.FIXED_TEACHERS_AND_TAS_FOR_ELECTIVES)

    await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
    this.attachingDataToCellForElective();
    this.props.handleCloseForDialog();
    this.props.handleClose();
  }

  creatingFixedTeachersAndTAsForElectivesObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
    let cellDetails_grade = cellDetails.grade
    let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
    let fixedTeachersAndTAsForElectivesArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives

    //JOINT CLASS ARRAY
    for (let a = 0; a < jointClassArray.length; a++) {
      let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
      if (cellDetails.elective && cellDetails.elective._id == jointClassObj.electiveId) {
        let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

        let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
        if (gradeIndex != -1) {

          //JOINT CLASS GRADE 
          for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
            let gradeObj = gradeDetails_gradesArray[b]

            // JOINT CLASS GROUPS 
            for (let c = 0; c < gradeObj.groups.length; c++) {
              let groupObj = gradeObj.groups[c];
              let isGroupObjPresent = false;

              //FIXED TEACHERS AND TAS FOR ELECTIVES FROM DATABASE
              for (let d = 0; d < fixedTeachersAndTAsForElectivesArray.length; d++) {
                let fixedTeachersAndTAsForElectiveObj = fixedTeachersAndTAsForElectivesArray[d];
                let fixedTeachersAndTAsForElectiveObj_grades = fixedTeachersAndTAsForElectiveObj.gradeDetails.grades[0]
                // REPLACING THE VALUES IN THE DATABASE ARRAY
                if (fixedTeachersAndTAsForElectiveObj_grades.grade === gradeObj.grade
                  && fixedTeachersAndTAsForElectiveObj_grades.groups != undefined
                  && fixedTeachersAndTAsForElectiveObj_grades.groups.length > 0
                  && fixedTeachersAndTAsForElectiveObj_grades.groups[0].groupCode === groupObj.groupCode) {

                  fixedTeachersAndTAsForElectiveObj.teachersAndTAs = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.teachersAndTAs))
                  fixedTeachersAndTAsForElectiveObj.jointClassId = jointClassObj._id
                  isGroupObjPresent = true
                  break;
                }
              }

              // CREATE NEW OBJECT FOR PARTICULAR GROUPS
              if (isGroupObjPresent === false) {
                let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
                delete tempObj._id;
                tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
                tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
                tempObj.jointClassId = jointClassObj._id
                fixedTeachersAndTAsForElectivesArray.push(tempObj);
              }
            }
          }
        }
      }
    }
  }

  attachingDataToCellForElective = () => {
    let fixedTeachersAndTAsForElectives = [...this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives];
    let dataTableMap = this.props.dataTableMap;
    for (let i = 0; i < fixedTeachersAndTAsForElectives.length; i++) {
      let grades = fixedTeachersAndTAsForElectives[i].gradeDetails.grades[0];

      //Attach data to GRADES
      if (this.props.filter.showSections === false) {
        if (grades.groups.length === 0) {
          for (let [key, value] of dataTableMap) {
            if ((value.elective && value.elective._id == fixedTeachersAndTAsForElectives[i].electiveId)) {
              if (value.grade === grades.grade) {
                value.fixedTeachersAndTAsForElective = fixedTeachersAndTAsForElectives[i];
                dataTableMap.set(key, value);
                break;
              }
            }
          }
        }
      }
      // Attach data to GROUPS
      else {
        if (grades.groups.length !== 0) {
          for (let [key, value] of dataTableMap) {
            if ((value.elective && value.elective._id == fixedTeachersAndTAsForElectives[i].electiveId)) {
              if (value.grade === grades.grade) {
                if (value.group === grades.groups[0].groupCode) {
                  value.fixedTeachersAndTAsForElective = fixedTeachersAndTAsForElectives[i];
                  dataTableMap.set(key, value);
                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  attachingDataToCellForSubjects = () => {
    let fixedTeachersAndTAsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects;
    let dataTableMap = this.props.dataTableMap;
    for (let i = 0; i < fixedTeachersAndTAsForSubjects.length; i++) {
      let grades = fixedTeachersAndTAsForSubjects[i].gradeDetails.grades[0];
      //Attach data to GRADES
      if (this.props.filter.showSections === false) {
        if (grades.groups.length === 0) {
          for (let [key, value] of dataTableMap) {
            if ((value.subject && value.subject._id == fixedTeachersAndTAsForSubjects[i].subjectId)) {
              if (value.grade === grades.grade) {
                value.fixedTeachersAndTAsForSubject = fixedTeachersAndTAsForSubjects[i];
                dataTableMap.set(key, value);
                break;
              }
            }
          }
        }
      }
      // Attach data to GROUPS
      else {
        if (grades.groups.length !== 0) {
          for (let [key, value] of dataTableMap) {
            if ((value.subject && value.subject._id == fixedTeachersAndTAsForSubjects[i].subjectId)) {
              if (value.grade === grades.grade) {
                if (value.group === grades.groups[0].groupCode) {
                  value.fixedTeachersAndTAsForSubject = fixedTeachersAndTAsForSubjects[i];
                  dataTableMap.set(key, value);
                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  showExistingFixedTeachersAndTAsForSubjects = () => {
    if (this.props.activeSchool.schedule_constraints !== undefined) {
      let fixedTeachersAndTAsForSubject = this.state.fixedTeachersAndTAsForSubject;
      let fixedTeachersAndTAsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects
      if (fixedTeachersAndTAsForSubjects !== undefined && fixedTeachersAndTAsForSubjects.length > 0) {
        let celldetails = this.props.dataTableMap.get(this.props.cellCode)
        // groups is not present

        if (this.props.filter.showSections === false && celldetails.groups === undefined) {
          for (let b = 0; b < fixedTeachersAndTAsForSubjects.length; b++) {
            if (fixedTeachersAndTAsForSubjects[b].gradeDetails.grades[0].groups.length === 0) {
              if ((celldetails.subject && celldetails.subject._id == fixedTeachersAndTAsForSubjects[b].subjectId) || (celldetails.elective && celldetails.elective._id == fixedTeachersAndTAsForSubjects[b].electiveId)) {
                let grade = fixedTeachersAndTAsForSubjects[b].gradeDetails.grades
                let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
                if (isObjectPresent !== undefined) {
                  if (isObjectPresent.groups.length === 0) {
                    let fixedTeachersAndTAsSubObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubjects[b]))
                    delete fixedTeachersAndTAsSubObj.gradeDetails
                    this.setState({
                      fixedTeachersAndTAsForSubject: fixedTeachersAndTAsSubObj
                    })

                  }
                }
              }
            }
          }
        }
        // group is present
        if (this.props.filter.showSections === true && celldetails.group !== undefined) {
          for (let c = 0; c < fixedTeachersAndTAsForSubjects.length; c++) {
            if (fixedTeachersAndTAsForSubjects[c].gradeDetails.grades[0].groups.length !== 0) {
              if ((celldetails.subject && celldetails.subject._id == fixedTeachersAndTAsForSubjects[c].subjectId) || (celldetails.elective && celldetails.elective._id == fixedTeachersAndTAsForSubjects[c].electiveId)) {
                let grades = fixedTeachersAndTAsForSubjects[c].gradeDetails.grades
                let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
                if (isObjPresent !== undefined) {
                  let groupCode = isObjPresent.groups[0].groupCode
                  if (groupCode === celldetails.group) {
                    let fixedTeachersAndTAsSubObj = JSON.parse(JSON.stringify(fixedTeachersAndTAsForSubjects[c]))
                    delete fixedTeachersAndTAsSubObj.gradeDetails
                    this.setState({
                      fixedTeachersAndTAsForSubject: fixedTeachersAndTAsSubObj
                    })
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  showExistingFixedTeachersAndTAsForElectives = () => {
    if (this.props.activeSchool.schedule_constraints !== undefined) {
      let fixedTeachersAndTAsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives
      if (fixedTeachersAndTAsForElectives !== undefined && fixedTeachersAndTAsForElectives.length > 0) {
        let celldetails = this.props.dataTableMap.get(this.props.cellCode)
        // groups is not present

        if (this.props.filter.showSections === false && celldetails.groups === undefined) {
          for (let b = 0; b < fixedTeachersAndTAsForElectives.length; b++) {
            if (fixedTeachersAndTAsForElectives[b].gradeDetails.grades[0].groups.length === 0) {
              if ((celldetails.elective && celldetails.elective._id == fixedTeachersAndTAsForElectives[b].electiveId)) {
                let grade = fixedTeachersAndTAsForElectives[b].gradeDetails.grades
                let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
                if (isObjectPresent !== undefined) {
                  if (isObjectPresent.groups.length === 0) {
                    this.setState({
                      fixedTeachersAndTAsForElective: JSON.parse(JSON.stringify(fixedTeachersAndTAsForElectives[b]))
                    })
                  }
                }
              }
            }
          }
        }
        // group is present
        if (this.props.filter.showSections === true && celldetails.group !== undefined) {
          for (let c = 0; c < fixedTeachersAndTAsForElectives.length; c++) {
            if (fixedTeachersAndTAsForElectives[c].gradeDetails.grades[0].groups.length !== 0) {
              if ((celldetails.elective && celldetails.elective._id == fixedTeachersAndTAsForElectives[c].electiveId)) {
                let grades = fixedTeachersAndTAsForElectives[c].gradeDetails.grades
                let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
                if (isObjPresent !== undefined) {
                  let groupCode = isObjPresent.groups[0].groupCode
                  if (groupCode === celldetails.group) {
                    this.setState({
                      fixedTeachersAndTAsForElective: JSON.parse(JSON.stringify(fixedTeachersAndTAsForElectives[c]))
                    })
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  render() {
    return (
      <MuiGrid>
        {this.state.isElective == false ?
          <FixedTeachersAndTAsComponent
            {...this.state}
            {...this.props}
            handleChangeForTeacherSubject={this.handleChangeForTeacherSubject}
            handleChangeForTAsSubject={this.handleChangeForTAsSubject}
            handleChangeForTeachers={this.handleChangeForTeachers}
            handleChangeForTA={this.handleChangeForTA}
            onClickOfSave={this.onClickOfSave}
          /> :
          <MuiGrid>

            <ElectivesFixedTeacherAndTAsComponent
              {...this.props}
              {...this.state}
              elective={this.state.elective}
              onClickOfSave={this.onClickOfSave}
              showTeachersAndTAs={this.showTeachersAndTAs}
              handleChangeForTeachersElectives={this.handleChangeForTeachersElectives}
              handleChangeForTAsElectives={this.handleChangeForTAsElectives}
            />
          </MuiGrid>}
      </MuiGrid>
    )
  }
}

export default FixedTeachersAndTAsContainer
